export default {"src":"/_next/static/media/ic-youtube-colorized.7f35fef9.svg","height":16,"width":16};